/* eslint-disable class-methods-use-this */
import { Injectable } from '@angular/core';
import { OrderedItemModifier } from '../../interfaces';
import { GratuityData } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class CartUtilService {
  public getModifiersTotal(modifiers: OrderedItemModifier[]): number {
    return modifiers.reduce((modTotals, mod) => {
      const quantity = mod.quantity || 1;
      const computedTotal = (mod.unitPrice || 0) * quantity;
      const hasPositiveExplicitPrice = typeof mod.price === 'number' && Number.isFinite(mod.price) && mod.price > 0;
      const modTotal = hasPositiveExplicitPrice ? mod.price : computedTotal;
      return modTotals + modTotal;
    }, 0);
  }

  public getGratuityFromPercentage(amount: number, gratuity: GratuityData): number {
    const gratValue = gratuity.value * 0.01;
    return Math.ceil(amount * gratValue);
  }
}
